import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;

  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .ant-table {
      min-width: ${({ theme }) => theme.mediaQueries.sm};
    }

    .ant-table-cell {
      word-break: break-word;
      white-space: normal;
    }
  }
`;
